import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '01',
      name: i18n.t('tipos.tax_code.iva'),
      short: i18n.t('tipos.tax_code.iva_short'),
    },
    {
      id: '02',
      name: i18n.t('tipos.tax_code.ipsi'),
      short: i18n.t('tipos.tax_code.ipsi_short'),
    },
    {
      id: '03',
      name: i18n.t('tipos.tax_code.igic'),
      short: i18n.t('tipos.tax_code.igic_short'),
    },
    {
      id: '04',
      name: i18n.t('tipos.tax_code.irpf'),
      short: i18n.t('tipos.tax_code.irpf_short'),
    },
    {
      id: '05',
      name: i18n.t('tipos.tax_code.other'),
      short: i18n.t('tipos.tax_code.other'),
    },
    {
      id: '06',
      name: i18n.t('tipos.tax_code.itpajd'),
      short: i18n.t('tipos.tax_code.itpajd_short'),
    },
    {
      id: '07',
      name: i18n.t('tipos.tax_code.ie'),
      short: i18n.t('tipos.tax_code.ie_short'),
    },
    {
      id: '08',
      name: i18n.t('tipos.tax_code.ra'),
      short: i18n.t('tipos.tax_code.ra_short'),
    },
    {
      id: '09',
      name: i18n.t('tipos.tax_code.igtecm'),
      short: i18n.t('tipos.tax_code.igtecm_short'),
    },
    {
      id: '10',
      name: i18n.t('tipos.tax_code.iecdpcac'),
      short: i18n.t('tipos.tax_code.iecdpcac_short'),
    },
    {
      id: '11',
      name: i18n.t('tipos.tax_code.iiimab'),
      short: i18n.t('tipos.tax_code.iiimab_short'),
    },
    {
      id: '12',
      name: i18n.t('tipos.tax_code.icio'),
      short: i18n.t('tipos.tax_code.icio_short'),
    },
    {
      id: '13',
      name: i18n.t('tipos.tax_code.imvdn'),
      short: i18n.t('tipos.tax_code.imvdn_short'),
    },
    {
      id: '14',
      name: i18n.t('tipos.tax_code.imsn'),
      short: i18n.t('tipos.tax_code.imsn_short'),
    },
    {
      id: '15',
      name: i18n.t('tipos.tax_code.imgsn'),
      short: i18n.t('tipos.tax_code.imgsn_short'),
    },
    {
      id: '16',
      name: i18n.t('tipos.tax_code.impn'),
      short: i18n.t('tipos.tax_code.impn_short'),
    },
    {
      id: '17',
      name: i18n.t('tipos.tax_code.reiva'),
      short: i18n.t('tipos.tax_code.reiva_short'),
    },
    {
      id: '18',
      name: i18n.t('tipos.tax_code.reigic'),
      short: i18n.t('tipos.tax_code.reigic_short'),
    },
    {
      id: '19',
      name: i18n.t('tipos.tax_code.reipsi'),
      short: i18n.t('tipos.tax_code.reipsi_short'),
    },
    {
      id: '20',
      name: i18n.t('tipos.tax_code.ips'),
      short: i18n.t('tipos.tax_code.ips_short'),
    },
    {
      id: '21',
      name: i18n.t('tipos.tax_code.rlea'),
      short: i18n.t('tipos.tax_code.rlea_short'),
    },
    {
      id: '22',
      name: i18n.t('tipos.tax_code.ivpee'),
      short: i18n.t('tipos.tax_code.ivpee_short'),
    },
    {
      id: '23',
      name: i18n.t('tipos.tax_code.nuclear_power_tax'),
      short: i18n.t('tipos.tax_code.nuclear_power_tax'),
    },
    {
      id: '24',
      name: i18n.t('tipos.tax_code.nuclear_fuel_storage_tax'),
      short: i18n.t('tipos.tax_code.nuclear_fuel_storage_tax'),
    },
    {
      id: '25',
      name: i18n.t('tipos.tax_code.idec'),
      short: i18n.t('tipos.tax_code.idec_short'),
    },
    {
      id: '26',
      name: i18n.t('tipos.tax_code.canary_tobacco_tax'),
      short: i18n.t('tipos.tax_code.canary_tobacco_tax'),
    },
    {
      id: '27',
      name: i18n.t('tipos.tax_code.igfei'),
      short: i18n.t('tipos.tax_code.igfei_short'),
    },
    {
      id: '28',
      name: i18n.t('tipos.tax_code.irnr'),
      short: i18n.t('tipos.tax_code.irnr_short'),
    },
    {
      id: '29',
      name: i18n.t('tipos.tax_code.corporate_income_tax'),
      short: i18n.t('tipos.tax_code.corporate_income_tax'),
    },
  ]
}

export function TIPOS_CODIGO_IMPUESTO (state) {
  return configHelper.getConfig(state, 'TIPOS_CODIGO_IMPUESTO', GenerateConfig)
}
